// Footer.js
import React from 'react';
import styles from '../styles/Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'; // Solid icon
import { faInstagram } from '@fortawesome/free-brands-svg-icons'; // Brand icon

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.gridOverlay}></div>
      <div className={styles.footerContent}>
        <div className={styles.brandSection}>
          <h1 className={styles.brandTitle}>StockKhata</h1>
          <p className={styles.brandSlogan}>Invest Anywhere Maintain Only Here</p>

          <div className={styles.socialLinks}>
            <a href="https://www.instagram.com/stockkhata/" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} className={styles.socialIcon} />
            </a>
            <a href="mailto:info@stockkhata.in">
              <FontAwesomeIcon icon={faEnvelope} className={styles.socialIcon} />
            </a>
          </div>
          <div className={styles.contactInfo}>
            <p>Email: info@stockkhata.in</p>
            <p>Phone: +91 7500068589</p>
          </div>
        </div>

        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>Navigation</h3>
          <div className={styles.footerLinks}>
            <a href="/login">Login</a>
            <a href="/signup">SignUp</a>
            <a href="#contact">Contact Us</a>
            {/* <a href="/threads-blogs">Blogs</a> */}
          </div>
        </div>

        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>Legal</h3>
          <div className={styles.footerLinks}>
            <a href="/disclaimer">Disclaimer</a>
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </div>

        {/* <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>Resources</h3>
          <div className={styles.footerLinks}>
            <a href="#academy">Trading Academy</a>
            <a href="#market-news">Market News</a>
          </div>
        </div> */}
      </div>

      <div className={styles.footerCopyright}>
        <p>© {new Date().getFullYear()} StockKhata. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;